import { shallowEqual } from 'react-redux';

import { useAppSelector } from 'app/hooks';
import { RootState } from '../app/store';

export const useAppSettings = () =>
  useAppSelector(
    (state: RootState) => ({
      settings: state.appSettings.settings,
      connectionError: state.appSettings.connectionError,
      status: state.appSettings.status,
      isSettingsInitialized: state.appSettings.isSettingsInitialized,
    }),
    shallowEqual,
  );

export const useAppTools = () =>
  useAppSelector((state: RootState) => state.appSettings.tools, shallowEqual);

export const useAppConnectionError = () =>
  useAppSelector(
    (state: RootState) => state.appSettings.connectionError,
    shallowEqual,
  );

export const useAppMaxmbs = () =>
  useAppSelector((state: RootState) => state.appSettings.maxmbs, shallowEqual);

export const useAppConfig = () =>
  useAppSelector((state: RootState) => state.appSettings.config, shallowEqual);

// Plain selector for use outside React components
export const selectAppSettings = (state: RootState) => ({
  settings: state.appSettings.settings,
  connectionError: state.appSettings.connectionError,
  status: state.appSettings.status,
  isSettingsInitialized: state.appSettings.isSettingsInitialized,
});
